import { render, staticRenderFns } from "./AggiungiTagPraticaInMassa.vue?vue&type=template&id=e4cfa4e0"
import script from "./AggiungiTagPraticaInMassa.vue?vue&type=script&lang=js"
export * from "./AggiungiTagPraticaInMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports